"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankAccountTypeEnum = void 0;
var BankAccountTypeEnum;
(function (BankAccountTypeEnum) {
    BankAccountTypeEnum["CHECKING"] = "Checking";
    BankAccountTypeEnum["CREDIT_CARD"] = "CreditCard";
    BankAccountTypeEnum["SAVINGS"] = "Savings";
})(BankAccountTypeEnum || (exports.BankAccountTypeEnum = BankAccountTypeEnum = {}));
